import { useQuery } from '@tanstack/react-query';
import { RollCompetitionsEntriesQueryKeys } from '../../queryKey';
import { GenericError } from '@/models/generic-error';
import { AxiosError } from 'axios';
import { fetchRollCompetitionEntriesMeWithPlace } from './service';
import {
  UseRollCompetitionEntriesMeProps,
  UseRollCompetitionEntriesMeQueryKeyProps,
} from './props';
import { RollCompetitionEntryWithPlace } from '@/models/roll-competition/entries/with-place/inde';
import { RollCompetitionEntriesMeRequestDto } from '@/services/dto/roll-competition-entries/roll-competition-entries-me-request.dto';
import { Nullable } from '@starsoft/common/interfaces';
import { useDispatch } from 'react-redux';
import {
  setIsAnimatingRollPointGame,
  setRollPointResult,
} from '@/lib/store/roll-point/actions';
import { useEffect } from 'react';
import { useUserAccount } from '@/api/user';
import { parseToBigInt } from '@starsoft/common/utils/parsers';

export function useRollCompetitionEntriesMeByCycleId({
  cycleId,
}: UseRollCompetitionEntriesMeProps) {
  const dispatch = useDispatch();
  const { isAuthorized } = useUserAccount();

  const filter: RollCompetitionEntriesMeRequestDto = {
    cycleId: parseToBigInt(cycleId) as bigint,
  };

  const queryKey: UseRollCompetitionEntriesMeQueryKeyProps = [
    RollCompetitionsEntriesQueryKeys.Me,
    filter,
  ];

  const { isPending, fetchStatus, data, error, refetch, isFetching } = useQuery<
    Nullable<RollCompetitionEntryWithPlace>,
    AxiosError<GenericError>,
    Nullable<RollCompetitionEntryWithPlace>,
    UseRollCompetitionEntriesMeQueryKeyProps
  >({
    queryKey,
    queryFn: fetchRollCompetitionEntriesMeWithPlace,
    staleTime: 5 * 1000,
    enabled: !!cycleId && isAuthorized,
  });

  function handleSuccess() {
    if (!data) {
      return;
    }

    dispatch(setIsAnimatingRollPointGame(true));
    dispatch(
      setRollPointResult(
        String(data?.rolled)?.padStart(3, '0')?.split('').map(Number),
      ),
    );
  }

  useEffect(handleSuccess, [data, dispatch]);

  return {
    isPending: isPending && fetchStatus !== 'idle',
    rollCompetitionEntriesMe: data,
    error,
    refetch,
    isFetching,
  };
}
